import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  atomFiltersCampaign,
  atomFiltersDropdownCampaign,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { IFiltersDropdownTableCampaign } from '@/modules/CampaignsModule/interfaces/Campaigns';
import { clearObjectFalsy } from '@/modules/CampaignsModule/utils';

export const useDropdownFilters = () => {
  const { t } = useTranslation();

  const [filtersDropdownCampaign, setFiltersDropdownCampaign] = useAtom(
    atomFiltersDropdownCampaign
  );
  const [filtersCampaign, setFiltersCampaign] = useAtom(atomFiltersCampaign);

  const countDropdownFilters = useMemo(() => {
    const { state, strategy } = filtersCampaign ?? {};
    return (state?.length ?? 0) + (strategy?.length ?? 0);
  }, [filtersCampaign]);

  const placeholderFilters = useMemo(() => {
    return countDropdownFilters > 0
      ? `${t('TABLE_FILTER_BAR.filters')} (${countDropdownFilters})`
      : t('TABLE_FILTER_BAR.filters');
  }, [countDropdownFilters, t]);

  const handleApplyFilters = useCallback(() => {
    const { state, strategy } = filtersDropdownCampaign ?? {};
    const clearedFilters = clearObjectFalsy({
      ...filtersCampaign,
      state,
      strategy,
    });

    setFiltersCampaign(clearedFilters);
  }, [filtersDropdownCampaign, filtersCampaign, setFiltersCampaign]);

  const handleCheckboxChange = useCallback(
    (key: keyof IFiltersDropdownTableCampaign, value: number, checked: boolean) => {
      const updatedFilters = { ...filtersDropdownCampaign };

      if (checked) {
        if (!updatedFilters[key]) {
          updatedFilters[key] = [value];
        } else {
          (updatedFilters[key] as number[]).push(value);
        }
      } else if (updatedFilters[key]) {
        updatedFilters[key] = (updatedFilters[key] as number[]).filter((item) => item !== value);
        if ((updatedFilters[key] as number[]).length === 0) {
          delete updatedFilters[key];
        }
      }

      setFiltersDropdownCampaign(updatedFilters);
    },
    [filtersDropdownCampaign, setFiltersDropdownCampaign]
  );

  return {
    state: {
      placeholderFilters,
      filtersDropdownCampaign,
    },
    events: {
      handleCheckboxChange,
      handleApplyFilters,
    },
  };
};
